<template>
  <div id="topPart">
    <div class="top">
      <div class="topHeader">
        <div class="topHeaderMain">
          <div class="topHeaderMainLeft">
            欢迎进入甘肃第二建设集团公司！！！
          </div>
          <div class="topHeaderMainRight">
            <span style="margin-right: 10px;"> <i class="iconfont">&#xe636;</i> 设为首页 </span>
            <span> <i class="iconfont">&#xe600;</i> 添加收藏 </span>
          </div>
        </div>
      </div>
      <div class="topLogo">
        <div class="topLogoMain">
          <div class="topLogoMainLeft">
            <a href="/"><img src="../../assets/image/logo(2).jpg" class="Nlogo"/></a>
          </div>
          <div class="topLogoMainRight">
            <div class="header_search">
              <div>
                <el-input v-model="searchValue" required="required" placeholder="请输入标题" style="width: 300px;"></el-input>
                <el-button
                  type="submit"
                  class="btn "
                  style="background-color:#0d65af; border-radius:0px;"
                  @click="handleSearch"
                  >搜索</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="topMenu">
        <div class="topMenuMain">
          <el-menu
            :default-active="route"
            class="el-menu-demo"
            background-color="rgba(0,0,0,0)"
            text-color="#ffffff"
            mode="horizontal"
            :router="true"
          >
            <div
              style="display:inline-block"
              :class="{ active: fullpath == item.url.split('/')[1] }"
              v-for="(item, index) in navSubList"
              :key="index"
            >
              <el-menu-item :index="item.url">{{ item.name }}</el-menu-item>
            </div>
          </el-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNavChannel } from '@/api/common'

export default {
  name: 'topPart',
  data() {
    return {
      searchValue: '',
      fullpath: '/homePage',
      navSubList: [
        {
          name:"网站首页",
          entTChannelUuid:'',
          url:"/homePage"
        },{
          name:"集团概况",
          entTChannelUuid:'0054',
          url:"/groupProfile/00540001"
        },{
          name:"新闻动态",
          entTChannelUuid:'0055',
          url:"/pressCenter/00550001"
        },{
          name:"党群工作",
          entTChannelUuid:'0060',
          url:"/businessUnit/00600002"
        },{
          name:"工程展示",
          entTChannelUuid:'0058',
          url:"/projectShow/00580002"
        },{
          name:"职工文苑",
          entTChannelUuid:'0059',
          url:"/culture/00590001"
        },{
          name:"招聘专栏",
          entTChannelUuid:'0166',
          url:"/newsPaper/01660001"
        },{
          name:"信息公开",
          entTChannelUuid:'0236 ',
          url:"/showInformation/02360006"
        },{
          name:"联系我们",
          entTChannelUuid:'0067',
          url:"/contactUs"
        },
      ],
      navList: [
        // {
        //   id: 1,
        //   name: '网站首页',
        //   index: '/homePage'
        // },
        {
          id: 2,
          name: '集团况',
          index: '/groupProfile'
        },
        {
          id: 3,
          name: '新闻动态',
          index: '/pressCenter'
        },
        {
          id: 4,
          name: '党群工作',
          index: '/businessUnit'
        },
        {
          id: 5,
          name: '工程展示',
          index: '/projectShow'
        },
        {
          id: 6,
          name: '职工文苑',
          index: '/culture'
        },
        {
          id: 7,
          name: '招聘专栏',
          index: '/newsPaper'
        },
        {
          id: 8,
          name: '联系我们',
          index: '/contactUs'
        }
      ]
    }
  },
  computed: {
    route() {
      return this.$store.state.route
    }
  },
  mounted() {
    var _this = this

     _this.getNavChannel()
    _this.fullpath = _this.$route.path.split('/')[1]
  },
  watch: {
    $route(val) {
      this.fullpath = val.path.split('/')[1]
    }
  },
  methods: {
    handleSearch() {
      var _this = this
      if (_this.searchValue == '') {
        this.$message({
          message: '请输入关键词',
          type: 'warning'
        })
      } else {
        window.location.href = `/search/${_this.searchValue}`
      }
    },
    // 获取一级导航
    getNavChannel() {
      var _this = this

      let data = {
        applicationUuid: _this.webId
      }
      getNavChannel(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          // data.length &&
          //   data.forEach((line, index) => {
          //     if (line.child.length) {
          //       line.url = _this.navList[index].index + '/' + line.child[0].entTChannelUuid
          //     } else {
          //       line.url = _this.navList[index].index + '/' + line.entTChannelUuid
          //     }
          // })
          _this.navSubList=[
            {
              id: 1,
              name: '网站首页',
              index: '/homePage'
            },
            ...data
          ]
          console.log("ceshi",_this.navSubList)
        }
      })
    }
  }
}

</script>

<style lang="scss">
#topPart{
  .iconfont {
    font-family: 'iconfont' !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0.2px;
    -moz-osx-font-smoothing: grayscale;
  }
}
@font-face {
  font-family: 'iconfont';  /* Project id 2488456 */
  src: url('//at.alicdn.com/t/font_2488456_vqjrjbiok4s.woff2?t=1646907605266') format('woff2'),
       url('//at.alicdn.com/t/font_2488456_vqjrjbiok4s.woff?t=1646907605266') format('woff'),
       url('//at.alicdn.com/t/font_2488456_vqjrjbiok4s.ttf?t=1646907605266') format('truetype');
}
.topHeader {
  width: 100%;
  height: auto;
  background-color: rgb(248,248,248);
  overflow: hidden;
  color: #a2a2a2;
  font-size: 14px;
  border-bottom: 1px solid #d4d4d4;
}
.topHeaderMain {
  width: 1200px;
  margin: 0 auto;
  height: 31px;
  line-height: 31px;
}
.topHeaderMainLeft {
  display: block;
  float: left;
  width: 340px;
  overflow: hidden;
}
.topHeaderMainRight {
  display: block;
  float: right;
  overflow: hidden;
  color: #a2a2a2;
}
.topLogo {
  overflow: hidden;
  padding: 10px 0px;
}
.topLogoMain {
  width: 1200px;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}
.topLogoMainLeft {
  width: 632px;
  overflow: hidden;
}
.topLogoMainLeft {
  float: left !important;
}
.topLogoMainRight {
  width: 380px;
  height: 50px;
  margin-top: 30px;
  overflow: hidden;
}
.topLogoMainRight {
  float: right !important;
}
.header_search {
  width: 380px;
  height: 51px;
  overflow: hidden;
  float: right;
  position: relative;
}
.header_search input {
  width: 300px;
  height: 38px;
  overflow: hidden;
  outline: none;
  box-shadow: none;
  line-height: 38px;
  font-size: 14px;
  color: #585858;
  border-radius: 0px;
  border: solid 1px #0d65af;
}

.form-control {
  display: block;
  padding: 6px 12px;
}
.btn {
  display: inline-block;
  height: 38px;
  line-height: 38px;
  padding: 0px 12px;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  border: none;
  cursor: pointer;
}
.topMenu {
  height: 46px;
  background-color: #0162b3;
  overflow: hidden;
  border-bottom: 1px #ffffff solid;
}
.topMenuMain {
  width: 100%;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
  text-align: center;
}
.el-menu-item {
  width: 148px;
  height: 60px;
  line-height: 46px;
  text-align: center;
  float: left;
  color: #ffffff;
  display: block;
  font-size: 16px;
}
.el-menu-item:hover {
  background-color: rgb(2,69,124) !important;
  color: #ffffff !important;
}
.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 60px;
  line-height: 52px;
  margin: 0;
  border-bottom: 2px solid transparent;
}
.el-menu .span1 {
  width: 2px;
  height: 50px;
  background: url(../../assets/image/menu_line.jpg) center center no-repeat;
  display: inline-block;
}
.el-menu .span2 {
  width: 2px;
  height: 50px;
  display: inline-block;
}
.topMenuMain .active .el-menu-item {
  color: #fff!important;
  background-color: rgb(2,69,124) !important;
}
.el-menu-item.is-active {
  color: #fff;
}
</style>
